import { SearchPillComponent } from '@app/shared/components/filter-bar/search-pill.component';
import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild  } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoggerService } from '@app/logger/logger.service';


import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('CUSTOM TABLE COMPONENT');

@Component({
  standalone: true,
  imports: [SearchPillComponent, FormsModule, ReactiveFormsModule, MaterialModule],
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss'],
})
export class CustomTableComponent implements OnInit, OnChanges {

  public columnsToDisplay = [];
  public displayedColumns = [];
  public dataSource = new MatTableDataSource([]);

  @Input() config: any;
  @Input() data: any;
  @Output() sentValue = new EventEmitter();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  constructor() {}

  async ngOnInit() {
    this.displayedColumns = this.config.structure;
    for (const element of this.displayedColumns) {
      this.columnsToDisplay.push(element.columnKey);
    }
    if(this.config.menu.length > 0){
      this.columnsToDisplay.push('more');
    }
  }
  
  /**@description Función para detectar cambios en los datos */
  ngOnChanges(changes: SimpleChanges) {
    this.dataSource = new MatTableDataSource(changes['data'].currentValue);
    this.dataSource.paginator = this.paginator;
  }

  /*** @description Filtro*/
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /**@description Función para enviar acción y elemento de tabla  */
  action(action: string, item: any) {
    this.sentValue.emit({action: action, item: item}); // Emitir el valor al padre
  }

  /**@description Función para llamar buscar datos */
  getData(){
    return this.dataSource?.filteredData;
  }

}
